import flatMap from 'lodash/flatMap';

export function mapAuthors(authors) {
    if (!authors) {
        return [];
    }

    return flatMap(authors, a => {
        const firstName = !a.firstName ? '' : `${a.firstName} `;
        a.name = `${firstName}${a.lastName}`;
        a.sortBy = `${a.lastName},${a.firstName}`;
        return a;
    });
}
